function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useContext, useMemo } from "react";
import Breakpoints from "../Breakpoints/Breakpoints";
import useCarinaReducer, { getCarinaActions } from "./useCarinaReducer";
import { GlobalTypography } from "../Typography";
import { ThemeProvider } from "../ThemeProvider";
import { createCtx } from "../../utils/createCtx";
import usePrefersColorScheme from "../../hooks/usePrefersColorScheme";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";
import { FlagsProvider } from "../FlagsProvider/index";
var ref = _slicedToArray(createCtx(), 3), useCarinaContext = ref[0], CarinaContextProvider = ref[1], CarinaContext = ref[2];
var CarinaConsumer = CarinaContext.Consumer;
var CarinaProvider = function(param) {
    var breakpoints = param.breakpoints, children = param.children, colorScheme = param.colorScheme, direction = param.direction, flags = param.flags, prefersReducedMotion = param.prefersReducedMotion, themeFunctions = param.themeFunctions, themes = param.themes;
    var parent = useContext(CarinaContext);
    var ref1 = _slicedToArray(useCarinaReducer({
        breakpoints: breakpoints,
        colorScheme: colorScheme,
        direction: direction,
        flags: flags,
        parent: parent,
        prefersReducedMotion: prefersReducedMotion,
        themeFunctions: themeFunctions,
        themes: themes
    }), 2), state = ref1[0], dispatch = ref1[1];
    var actions = useMemo(function() {
        return getCarinaActions(dispatch);
    }, [
        dispatch
    ]);
    var setPrefersReducedMotion = actions.setPrefersReducedMotion, setColorScheme = actions.setColorScheme;
    usePrefersColorScheme({
        callback: setColorScheme,
        colorScheme: colorScheme
    });
    usePrefersReducedMotion({
        callback: setPrefersReducedMotion,
        prefersReducedMotion: prefersReducedMotion
    });
    return _jsx(CarinaContextProvider, {
        value: _objectSpread({}, state, actions),
        children: _jsx(FlagsProvider, {
            flags: state.flags,
            children: _jsx(ThemeProvider, {
                theme: state.theme,
                children: _jsxs(Breakpoints, _objectSpread({}, state.breakpoints, {
                    children: [
                        state.depth === 1 && _jsx(GlobalTypography, {}),
                        children
                    ]
                }))
            })
        })
    });
};
export { CarinaProvider, useCarinaContext, CarinaContext, CarinaConsumer };
export default CarinaProvider;
